import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';

// STYLES
import { scrollToRef } from '@/utility/common';
import { Container } from './styles';

const Anchors = ({ className, data, title, loading }) => {
  const [t] = useTranslation();

  const handleScrollToRef = ref => () => scrollToRef(ref, 113);

  return (
    <Container className={clsx('anchors', className)}>
      {loading ? (
        <Skeleton height={30} width={200} />
      ) : (
        <>
          {!!title && <Typography className="p4 anchors__title">{title}</Typography>}
          <ul>
            {data.map((item, index) => (
              <li key={index}>
                <Link onClick={handleScrollToRef(item.ref, 500)} color="inherit">
                  {t(item.title)}
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </Container>
  );
};

Anchors.defaultProps = {
  className: '',
  title: '',
  loading: false,
};

Anchors.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  loading: PropTypes.bool,
  data: PropTypes.array.isRequired,
};

export default Anchors;
